import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Apenas confirmado el pago recibís un email con el link de descarga. Acceso inmediato a los 20 PDFs. Sin esperas. Sin instalaciones.'
}, {
  q: '¿Sirve si recién me recibí o si tengo años de experiencia?',
  a: 'Sí. Si sos nuevo, te da el sistema que la facultad no te enseñó. Si tenés experiencia, te ordena y profesionaliza lo que ya sabés hacer.'
}, {
  q: '¿Los 6 Bonus están en las dos opciones?',
  a: 'Sí. Los 6 Bonus estratégicos están incluidos tanto en el Pack Profesional como en el Megapack Élite.'
}, {
  q: '¿Qué diferencia hay con otros materiales que ya existen?',
  a: 'La mayoría de los recursos de kinesiología son académicos o teóricos. Kinesiología Práctica son herramientas listas para aplicar en camilla o en el escritorio. Sin traducción. Sin adaptación.'
}, {
  q: '¿Sirve si atiendo distintas especialidades?',
  a: 'Sí. Los 12 Tomos cubren traumatología, ortopedia, columna, internación domiciliaria y gestión. Usás los que corresponden a tu práctica actual.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Vale la pena el Megapack Élite si ya trabajo con post-quirúrgicos?',
  a: 'Si ya trabajás con post-quirúrgicos, el Élite 2 te da el respaldo formal que necesitás para progresar con criterios biológicos objetivos y detectar complicaciones antes que el médico.'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-slate-50 px-4 sm:px-6 lg:px-8" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center text-slate-900 mb-10" data-id="element-20">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none focus:bg-slate-50" aria-expanded={openIndex === i} data-id="element-23">
                <span className="font-bold text-slate-800 pr-4" data-id="element-24">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-200 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-25" />
              </button>
              <AnimatePresence data-id="element-26">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-27">
                    <div className="px-6 pb-4 text-slate-600 border-t border-slate-100 pt-4" data-id="element-28">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};
export const Footer = () => {
  return <footer className="bg-slate-900 text-slate-300 py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800" data-id="element-29">
      <div className="max-w-5xl mx-auto text-center" data-id="element-30">
        <div className="mb-8" data-id="element-31">
          <h2 className="text-2xl font-black text-white mb-2 flex items-center justify-center gap-2" data-id="element-32">
            🦴 KINESIOLOGÍA PRÁCTICA
          </h2>
          <p className="text-slate-400 font-medium" data-id="element-33">
            El sistema de gestión clínica N°1 para kinesiólogos independientes
            argentinos.
          </p>
        </div>

        <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 mb-8 max-w-2xl mx-auto" data-id="element-34">
          <p className="text-lg italic text-slate-200" data-id="element-35">
            "Porque atender bien a tus pacientes no debería costarte todas las
            noches de la semana."
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8 text-sm font-medium" data-id="element-36">
          <a href="mailto:contacto@kinesiologiapractica.com.ar" className="flex items-center gap-2 hover:text-white transition" data-id="element-37">
            📧 contacto@kinesiologiapractica.com.ar
          </a>
          <span className="hidden md:inline text-slate-600" data-id="element-38">|</span>
          <span className="flex items-center gap-2" data-id="element-39">
            📲 @kinesiologiapractica.ar
          </span>
          <span className="hidden md:inline text-slate-600" data-id="element-40">|</span>
          <span className="flex items-center gap-2" data-id="element-41">
            🌐 www.kinesiologiapractica.com.ar
          </span>
        </div>

        <div className="text-xs text-slate-500 border-t border-slate-800 pt-8" data-id="element-42">
          <p className="mb-2" data-id="element-43">KINESIOLOGÍA PRÁCTICA™</p>
          <p data-id="element-44">
            © KINESIOLOGÍA PRÁCTICA™ 2025 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
};